<template>
  <div
    class="flex -m-4 mb-1"
    :class="vertical ? 'items-start flex-col' : 'items-center'"
  >
    <div
      class="p-4"
      :class="{ 'w-full': vertical }"
      v-for="(option, optionIndex) in options"
      :key="`cf${option.value}`"
    >
      <label class="custom-radio">
        {{ option.label }}

        <span
          class="flex-1 flex items-center"
          v-if="option.images && option.images.length"
        >
          <img
            class="icon mx-4 my-1"
            v-for="image in option.images"
            :key="`oi${image.url}`"
            :src="image.url"
            :alt="image.name"
          />
        </span>
        <input
          :id="`${id}${optionIndex}`"
          :value="option.value"
          type="radio"
          v-bind="$attrs"
          :checked="option.value === modelValue"
          @input="$emit('update:modelValue', option.value)"
        />
        <span></span>
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BooleanGroupField',
  props: {
    id: {
      type: [String, Number],
      default: '',
    },
    label: {
      type: String,
    },
    vertical: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Array,
      required: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
    modelValue: String,
  },
  emits: ['update:modelValue'],
}
</script>
